import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";

import Button from "./Button";

const PlusButton = ({ onClick }) => {
    return (
        <Button
            onClick={onClick}
            className="ml-4 px-1 py-1"
        >
            <FontAwesomeIcon
                icon={faPlus}
                className={'fa-lg'}
            />
        </Button>
    )
}

export default PlusButton;